/* src/pages/start/page-start.component.scss */
:host {
  display: block;
}
.box-wrapper {
  padding: 20px;
}
.title {
  border-bottom: 1px solid var(--vwui-border-color-light);
  padding: 0 0 25px 0;
  margin: 0 0 30px 0;
}
/*# sourceMappingURL=page-start.component-EEKOTZIV.css.map */
